import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { CreateConnection } from '../models/account.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyLogisticsService implements OnDestroy{
  private url = 'api/thirdpartylogistics';
  private destroy$ = new Subject<void>();
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  constructor(private http: HttpClient) { }

  public GetCompanies() {
    return this.http.get(`/${this.url}/GetCompanies`, this.options);
  }

  public GetConnectedCompanies() {
    return this.http.get(`/${this.url}/GetConnectedCompanies`, this.options);
  }

  public CreateApp(payload : CreateConnection) {
    const data = JSON.stringify(payload);
    return this.http.post(`/${this.url}/CreateApp`,data,this.options);
  }

  public removeCompanies(payload) {
    const data = JSON.stringify(payload);
    return this.http.post(`/${this.url}/RemoveConnectedCompany`,data, this.options);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
